import React from "react";
import { useTheme } from "../../contexts/theme-context";
import { SunIcon, MoonIcon, ComputerDesktopIcon } from "@heroicons/react/24/outline";

export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();

  const buttonClass = (active: boolean) =>
    `inline-flex items-center justify-center min-h-11 min-w-11 rounded-md transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ergo-500 ${
      active
        ? "bg-ergo-100 text-ergo-600 dark:bg-ergo-900 dark:text-ergo-100"
        : "text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100"
    }`;

  return (
    <div className="flex items-center gap-2" role="group" aria-label="Darstellung wählen">
      <button
        type="button"
        onClick={() => setTheme("light")}
        className={buttonClass(theme === "light")}
        aria-label="Helles Design"
        aria-pressed={theme === "light"}
      >
        <SunIcon className="h-4 w-4" aria-hidden="true" />
      </button>
      <button
        type="button"
        onClick={() => setTheme("dark")}
        className={buttonClass(theme === "dark")}
        aria-label="Dunkles Design"
        aria-pressed={theme === "dark"}
      >
        <MoonIcon className="h-4 w-4" aria-hidden="true" />
      </button>
      <button
        type="button"
        onClick={() => setTheme("system")}
        className={buttonClass(theme === "system")}
        aria-label="Systemeinstellung"
        aria-pressed={theme === "system"}
      >
        <ComputerDesktopIcon className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
}
